export const ORDER_ASCENDING = 'asc';
export const ORDER_DESCENDING = 'desc';

export const LINK_CELL_ROUTE_POPULATOR = 'route';
export const LINK_CELL_TEMPLATE_POPULATOR = 'template';
